// extracted by css-extract-rspack-plugin
export default {"styledLogos":"Highlight-module__styledLogos__hTmKu","styledTestimonial":"Highlight-module__styledTestimonial__lnf1j"};